/**
 * Amounts are integer cents everywhere (ADR 0002). This module only formats and reads amounts;
 * prices themselves always come from the server (ADR 0007).
 */
export type Cents = number;

const euro = new Intl.NumberFormat("nl-BE", { style: "currency", currency: "EUR" });
const plain = new Intl.NumberFormat("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** 1690 → "€ 16,90" */
export function formatEuro(cents: Cents): string {
  return euro.format(cents / 100);
}

/** 1690 → "16,90" */
export function formatAmount(cents: Cents): string {
  return plain.format(cents / 100);
}

/** Menu prices are stored in euros with at most two decimals. */
export function eurosToCents(euros: number): Cents {
  return Math.round(euros * 100);
}

/**
 * Reads an amount typed on the keypad or keyboard: "35", "35,4", "35.40". Returns null when it is
 * not a valid amount (more than two decimals, letters, empty).
 */
export function parseAmount(text: string): Cents | null {
  const match = /^(\d{1,6})(?:[.,](\d{0,2}))?$/.exec(text.trim());
  if (!match) return null;
  const whole = Number(match[1]);
  const fraction = (match[2] ?? "").padEnd(2, "0");
  return whole * 100 + Number(fraction);
}
